// import React from "react";

// export function renderBillToHtml(bill = {}) {
//   const createdDateObj = bill.date ? new Date(bill.date) : new Date();
//   const formattedDate = createdDateObj.toLocaleDateString("en-GB", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//   });
//   const formattedTime = createdDateObj.toLocaleTimeString("en-GB", {
//     hour: "2-digit",
//     minute: "2-digit",
//   });

//   const items = Array.isArray(bill.items) ? bill.items : [];

//   const total = Number(
//     bill.total ??
//       items.reduce(
//         (s, it) => s + Number(it.price || 0) * Number(it.quantity || 0),
//         0
//       )
//   );
//   const paid = Number(bill.paid || 0);
//   const balance = Number(bill.balance ?? Math.max(0, total - paid));

//   const totalFmt = total.toFixed(2);
//   const paidFmt = paid.toFixed(2);
//   const balanceFmt = balance.toFixed(2);

//   // Pagination settings
//   const chunkSize = 12; // rows per page
//   let pages = [];
//   if (items.length === 0) pages = [[]];
//   else {
//     for (let i = 0; i < items.length; i += chunkSize) {
//       pages.push(items.slice(i, i + chunkSize));
//     }
//   }

//   const generatePage = (pageItems, pageIndex) => {
//     const isLastPage = pageIndex === pages.length - 1;
//     const startIndex = pageIndex * chunkSize;

//     const rowsHtml = pageItems
//       .map((item, idx) => {
//         const price = Number(item.price || 0);
//         const qty = Number(item.quantity || 0);
//         const amt = (price * qty).toFixed(2);
//         const name = item.product || item.name || "-";
//         return `
//           <tr>
//             <td class="col-center">${startIndex + idx + 1}</td>
//             <td>${name}</td>
//             <td class="col-right">₹${price.toFixed(2)}</td>
//             <td class="col-center">${qty}</td>
//             <td class="col-right">₹${amt}</td>
//           </tr>`;
//       })
//       .join("");

//     const emptyRowsCount = Math.max(0, chunkSize - pageItems.length);
//     const emptyRows = Array.from({ length: emptyRowsCount })
//       .map(
//         () => `
//         <tr>
//           <td class="col-center">&nbsp;</td>
//           <td></td>
//           <td class="col-right"></td>
//           <td class="col-center"></td>
//           <td class="col-right"></td>
//         </tr>`
//       )
//       .join("");

//     return `

//       <div class="page">

//         <div class="header">
//           <div class="logo"  style="width: 120px; height: 120px;">
//             <img src="${bill.logoPath || "/logo.png"}" alt="logo" />
//           </div>

//           <div class="title">
//             <p>உ</p>
//             <p style="font-size:14px; font-weight:600; margin:0 0 6px;">ஸ்ரீ பெரியாண்டவர் துணை</p>
//             <h1>ஸ்ரீ முருகன் ஆயுர்வேத</h1>
//             <h2>ஆலோசனை மையம்</h2>
//             <p style="font-size:14px; font-weight:600;">142-A, அந்தியூர் மேயின் ரோடு, லட்சுமி மருத்துவமனை அருகில், பவானி - 638 301</p>
//           </div>
//         </div>

//         <div class="body">
//           <div class="info-box">
//             <div class="info-left">
//               <div><strong>To:</strong> ${
//                 bill.workerName || bill.customerName || "—"
//               }</div>
//               <div><strong>Address:</strong> ${bill.address || "—"}</div>
//               <div><strong>Mobile:</strong> ${bill.mobile || "—"}</div>
//               ${
//                 bill.gst ? `<div><strong>GSTIN:</strong> ${bill.gst}</div>` : ""
//               }
//             </div>
//             <div class="info-right">
//               <div><strong>Invoice No :</strong> ${bill.invoiceNo || "—"}</div>
//               <div><strong>Date :</strong> ${formattedDate}</div>
//               <div><strong>Time :</strong> ${formattedTime}</div>
//             </div>
//           </div>

//           <div class="table-wrapper">
//             <!-- single centered watermark for the rows area -->
//             <div class="table-watermark--table" aria-hidden="true">
//               <img src="${
//                 bill.logoPath1 || "/logo1.png"
//               }" alt="table-watermark" />
//             </div>

//             <table class="items" style="position:relative; z-index:1;">
//               <thead>
//                 <tr>
//                   <th style="width:6%;">S.No</th>
//                   <th style="width:54%;">Particulars</th>
//                   <th style="width:14%; text-align:right;">Rate</th>
//                   <th style="width:8%; text-align:center;">Qty</th>
//                   <th style="width:18%; text-align:right;">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${rowsHtml}
//                 ${emptyRows}
//               </tbody>
//             </table>
//           </div>

//           ${
//             isLastPage
//               ? `
//           <div class="sub-box">
//             <table class="sub-table">
//               <tr><td class="label">Sub Total</td><td class="val">₹${totalFmt}</td></tr>
//               ${
//                 bill.discount
//                   ? `<tr><td class="label">Discount</td><td class="val">₹${Number(
//                       bill.discount
//                     ).toFixed(2)}</td></tr>`
//                   : ""
//               }
//               <tr><td class="label">Net Amount</td><td class="val">₹${totalFmt}</td></tr>
//               ${
//                 bill.payment_type === "Credit"
//                   ? `<tr><td class="label">Paid</td><td class="val">₹${paidFmt}</td></tr>
//                      <tr><td class="label">Balance Due</td><td class="val">₹${balanceFmt}</td></tr>`
//                   : `<tr><td class="label">Payment Type</td><td class="val">${
//                       bill.payment_type || "Cash"
//                     }</td></tr>`
//               }
//             </table>
//           </div>

//           <div class="totals-line">
//             <div>Total Items: ${items.reduce(
//               (s, it) => s + Number(it.quantity || 0),
//               0
//             )}</div>
//             <div>Total Amount: ₹${totalFmt}</div>
//           </div>

//           <div class="footer-note">குறிப்பு : ஒருமுறை விற்ற பொருள் திரும்ப பெறப்படமாட்டாது</div>
//           `
//               : `<div class="footer-note" style="margin-top:40px; text-align:center;">Page ${
//                   pageIndex + 1
//                 } of ${pages.length}</div>`
//           }

//         </div>

//         <div class="bottom-bar">📞 ${bill.contact1 || "99408 32688"} , ${
//       bill.contact2 || "90801 99109"
//     }</div>
//       </div>
//       ${
//         pageIndex < pages.length - 1
//           ? `<div style="page-break-after: always;"></div>`
//           : ""
//       }

//     `;
//   };

//   const allPagesHtml = pages.map((p, idx) => generatePage(p, idx)).join("");

//   return `<!doctype html>
// <html lang="ta">
// <head>
//   <meta charset="utf-8" />
//   <title>Invoice ${bill.invoiceNo || ""}</title>
//   <meta name="viewport" content="width=device-width,initial-scale=1" />
//   <style>
//     * { box-sizing: border-box; }
//     html,body { margin:0; padding:0; -webkit-print-color-adjust: exact; print-color-adjust: exact; font-family:"Helvetica Neue", Arial, sans-serif; background:#f4f4f4; }
//     .page {
//       width: 210mm;
//       min-height: 287mm;
//       background: #fff;
//       box-shadow: 0 2px 8px rgba(0,0,0,0.06);
//       margin: 12mm auto;
//       position: relative;
//       padding-bottom: 70px; /* space for bottom bar */
//       overflow: hidden;
//     }

//     /* header */
//     .header { width:100%; background:#d81b2e; display:flex; align-items:center; justify-content:center; padding:16px 12px; position:relative; }
//     .logo { position:absolute; left:24px; top:12px; width:86px; height:86px; border-radius:8px; padding:6px; display:flex; align-items:center; justify-content:center; overflow:hidden;  }
//     .logo img { width:76px; height:76px; object-fit:cover; }
//     .title { text-align:center; color:#fff; line-height:1; }
//     .title h1 { font-size:28px; font-weight:900; margin:0; line-height:1.05; }
//     .title h2 { font-size:18px; font-weight:700; margin:4px 0 0; }
//     .title p { font-size:12.5px; margin:6px 0 0; color:#fff; }

//     .body {
//       padding: 18px 24px 32px;
//       position: relative;
//       z-index: 2;
//     }

//     .info-box { border:1px solid rgba(0,0,0,0.18); border-radius:6px; padding:12px 16px; margin-top:8px; display:flex; gap:18px; background:#fff; justify-content:space-between; align-items:flex-start; }
//     .info-left { font-size:13.5px; line-height:1.7; flex:1 1 60%; }
//     .info-right { display:grid; gap:6px 12px; font-size:13.5px; line-height:1.7; width:220px; text-align:right; }

//     .table-wrapper { position:relative; width:100%; display:inline-block; margin-top:14px; }

//     /* Single centered watermark inside the table wrapper */
//     .table-watermark--table {
//       position: absolute;
//       top: 50%;
//       left: 50%;
//       transform: translate(-50%, -50%);
//       opacity: 0.12;
//       z-index: 0;               /* behind the table */
//       pointer-events: none;
//       filter: blur(1.2px);
//       width: 360px;             /* control watermark size */
//       max-width: 60%;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//     .table-watermark--table img {
//       width: 100%;
//       height: auto;
//       display:block;
//     }

//     table.items { width:100%; border-collapse:collapse; margin-top:6px; font-size:13.5px; border:1px solid rgba(0,0,0,0.25); position:relative; z-index:1; }
//     table.items th, table.items td { padding:8px 8px; border:1px solid rgba(0,0,0,0.12); background:transparent; }
//     table.items thead th { background:#f9f9f9; font-weight:700; font-size:13px; }
//     .col-center { text-align:center; }
//     .col-right { text-align:right; }

//     .sub-box { margin-top:16px; display:flex; justify-content:flex-end; }
//     .sub-table { width:340px; border-collapse:collapse; font-size:13.5px; }
//     .sub-table td { padding:8px 6px; border-top:1px solid rgba(0,0,0,0.08); }
//     .sub-table .label { text-align:left; color:#222; }
//     .sub-table .val { text-align:right; font-weight:700; }

//     .totals-line { margin-top:18px; font-size:15px; font-weight:700; display:flex; justify-content:space-between; }

//     .footer-note { margin-top: 12px; font-size:13px; color: #111; }

//     .bottom-bar {
//       background: #d81b2e;
//       color: #fff;
//       padding: 10px 8px;
//       text-align: center;
//       font-weight: 800;
//       font-size: 14px;
//       position: absolute;
//       bottom: 0;
//       left: 0;
//       right: 0;
//       width: 100%;
//       line-height: 1.4;
//     }

//     @media print {
//       html, body { background: #fff; margin: 0; padding: 0; }
//       .page { width: auto; margin: 0; box-shadow: none; min-height: auto; padding-bottom: 70px; }
//       @page { size: A4; margin: 6mm; }
//       .bottom-bar { position: fixed; bottom: 0; left: 0; right: 0; }
//     }
//   </style>
// </head>
// <body>
//   ${allPagesHtml}
// </body>
// </html>`;
// }

// export function BillPrintPreview({ bill }) {
//   const html = renderBillToHtml(bill);
//   return <div dangerouslySetInnerHTML={{ __html: html }} />;
// }

// export default BillPrintPreview;

// import React from "react";

// export function renderBillToHtml(bill = {}) {
//   const createdDateObj = bill.date ? new Date(bill.date) : new Date();
//   const formattedDate = createdDateObj.toLocaleDateString("en-GB", {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//   });
//   const formattedTime = createdDateObj.toLocaleTimeString("en-GB", {
//     hour: "2-digit",
//     minute: "2-digit",
//   });

//   const items = Array.isArray(bill.items) ? bill.items : [];

//   const total = Number(
//     bill.total ??
//       items.reduce(
//         (s, it) => s + Number(it.price || 0) * Number(it.quantity || 0),
//         0
//       )
//   );
//   const paid = Number(bill.paid || 0);
//   const balance = Number(bill.balance ?? Math.max(0, total - paid));

//   const totalFmt = total.toFixed(2);
//   const paidFmt = paid.toFixed(2);
//   const balanceFmt = balance.toFixed(2);

//   // Pagination settings
//   const chunkSize = 12; // rows per page
//   let pages = [];
//   if (items.length === 0) pages = [[]];
//   else {
//     for (let i = 0; i < items.length; i += chunkSize) {
//       pages.push(items.slice(i, i + chunkSize));
//     }
//   }

//   const generatePage = (pageItems, pageIndex) => {
//     const isLastPage = pageIndex === pages.length - 1;
//     const startIndex = pageIndex * chunkSize;

//     const rowsHtml = pageItems
//       .map((item, idx) => {
//         const price = Number(item.price || 0);
//         const qty = Number(item.quantity || 0);
//         const amt = (price * qty).toFixed(2);
//         const name = item.product || item.name || "-";
//         return `
//           <tr>
//             <td class="col-center">${startIndex + idx + 1}</td>
//             <td>${name}</td>
//             <td class="col-right">₹${price.toFixed(2)}</td>
//             <td class="col-center">${qty}</td>
//             <td class="col-right">₹${amt}</td>
//           </tr>`;
//       })
//       .join("");

//     const emptyRowsCount = Math.max(0, chunkSize - pageItems.length);
//     const emptyRows = Array.from({ length: emptyRowsCount })
//       .map(
//         () => `
//         <tr>
//           <td class="col-center">&nbsp;</td>
//           <td></td>
//           <td class="col-right"></td>
//           <td class="col-center"></td>
//           <td class="col-right"></td>
//         </tr>`
//       )
//       .join("");

//     return `

//       <div class="page">

//         <div class="header">
//           <div class="header-top">${bill.headerTopText || ""}</div>

//           <div class="logo"  style="width: 96px; height: 96px;">
//             <div class="logo-circle">
//               <img src="${bill.logoPath || "/logo.png"}" alt="logo" />
//             </div>
//           </div>

//           <div class="title">
//             <p style="font-size:13px; margin:0 0 6px; font-weight:700;">${
//               bill.subtitleTop || "ஸ்ரீ பெரியாண்டவர் துணை"
//             }</p>
//             <h1>${bill.titleLine1 || "ஸ்ரீ முருகன் ஆயுர்வேத"}</h1>
//             <h2>${bill.titleLine2 || "ஆலோசனை மையம்"}</h2>
//             <p style="font-size:13px; margin:8px 0 0; font-weight:600;">${
//               bill.addressLine ||
//               "142-A, அந்தியூர் மேயின் ரோடு, லட்சுமி மருத்துவமனை அருகில், பவானி - 638 301"
//             }</p>
//           </div>
//         </div>

//         <div class="body">
//           <div class="info-box">
//             <div class="info-left">
//               <div><strong>To:</strong> ${
//                 bill.workerName || bill.customerName || "—"
//               }</div>
//               <div><strong>Address:</strong> ${bill.address || "—"}</div>
//               <div><strong>Mobile:</strong> ${bill.mobile || "—"}</div>
//               ${
//                 bill.gst ? `<div><strong>GSTIN:</strong> ${bill.gst}</div>` : ""
//               }
//             </div>
//             <div class="info-right">
//               <div><strong>Invoice No :</strong> ${bill.invoiceNo || "—"}</div>
//               <div><strong>Date :</strong> ${formattedDate}</div>
//               <div><strong>Time :</strong> ${formattedTime}</div>
//             </div>
//           </div>

//           <div class="table-wrapper">
//             <!-- single centered watermark for the rows area -->
//             <div class="table-watermark--table" aria-hidden="true">
//               <img src="${
//                 bill.logoPath1 || "/logo1.png"
//               }" alt="table-watermark" />
//             </div>

//             <table class="items" style="position:relative; z-index:1;">
//               <thead>
//                 <tr>
//                   <th style="width:6%;">S.No</th>
//                   <th style="width:54%;">Particulars</th>
//                   <th style="width:14%; text-align:right;">Rate</th>
//                   <th style="width:8%; text-align:center;">Qty</th>
//                   <th style="width:18%; text-align:right;">Amount</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 ${rowsHtml}
//                 ${emptyRows}
//               </tbody>
//             </table>
//           </div>

//           ${
//             isLastPage
//               ? `
//           <div class="sub-box">
//             <table class="sub-table">
//               <tr><td class="label">Sub Total</td><td class="val">₹${totalFmt}</td></tr>
//               ${
//                 bill.discount
//                   ? `<tr><td class="label">Discount</td><td class="val">₹${Number(
//                       bill.discount
//                     ).toFixed(2)}</td></tr>`
//                   : ""
//               }
//               <tr><td class="label">Net Amount</td><td class="val">₹${totalFmt}</td></tr>
//               ${
//                 bill.payment_type === "Credit"
//                   ? `<tr><td class="label">Paid</td><td class="val">₹${paidFmt}</td></tr>
//                      <tr><td class="label">Balance Due</td><td class="val">₹${balanceFmt}</td></tr>`
//                   : `<tr><td class="label">Payment Type</td><td class="val">${
//                       bill.payment_type || "Cash"
//                     }</td></tr>`
//               }
//             </table>
//           </div>

//           <div class="totals-line">
//             <div>Total Items: ${items.reduce(
//               (s, it) => s + Number(it.quantity || 0),
//               0
//             )}</div>
//             <div>Total Amount: ₹${totalFmt}</div>
//           </div>

//           <div class="footer-note">குறிப்பு : ஒருமுறை விற்ற பொருள் திரும்ப பெறப்படமாட்டாது</div>
//           `
//               : `<div class="footer-note" style="margin-top:40px; text-align:center;">Page ${
//                   pageIndex + 1
//                 } of ${pages.length}</div>`
//           }

//         </div>

//         <div class="bottom-bar">📞 ${bill.contact1 || "99408 32688"} , ${
//       bill.contact2 || "90801 99109"
//     }</div>
//       </div>
//       ${
//         pageIndex < pages.length - 1
//           ? `<div style="page-break-after: always;"></div>`
//           : ""
//       }

//     `;
//   };

//   const allPagesHtml = pages.map((p, idx) => generatePage(p, idx)).join("");

//   return `<!doctype html>
// <html lang="ta">
// <head>
//   <meta charset="utf-8" />
//   <title>Invoice ${bill.invoiceNo || ""}</title>
//   <meta name="viewport" content="width=device-width,initial-scale=1" />
//   <style>
//     * { box-sizing: border-box; }
//     html,body { margin:0; padding:0; -webkit-print-color-adjust: exact; print-color-adjust: exact; font-family:"Helvetica Neue", Arial, sans-serif; background:#f4f4f4; }
//     .page {
//       width: 210mm;
//       min-height: 287mm;
//       background: #fff;
//       box-shadow: 0 2px 8px rgba(0,0,0,0.06);
//       margin: 12mm auto;
//       position: relative;
//       padding-bottom: 70px; /* space for bottom bar */
//       overflow: hidden;
//     }

//     /* header */
//     .header {
//       width:100%;
//       background:#d81b2e;
//       display:flex;
//       align-items:center;
//       justify-content:center;
//       padding:28px 20px 22px;
//       position:relative;
//       overflow:visible;
//     }

//     /* small top centered white text (as in first image) */
//     .header-top {
//       position: absolute;
//       top: 6px;
//       left: 0;
//       right: 0;
//       text-align: center;
//       font-size: 12px;
//       color: #fff;
//       font-weight: 800;
//       letter-spacing: 0.4px;
//     }

//     /* large circular logo at left with white background */
//     .logo {
//       position: absolute;
//       left: 18px;
//       top: 14px;
//       width: 96px;
//       height: 96px;
//       display:flex;
//       align-items:center;
//       justify-content:center;
//     }
//     .logo-circle {
//       width:86px;
//       height:86px;
//       border-radius:50%;
//       background:#fff;
//       display:flex;
//       align-items:center;
//       justify-content:center;
//       box-shadow: 0 2px 6px rgba(0,0,0,0.12);
//       padding:6px;
//       overflow:hidden;
//     }
//     .logo-circle img { width:74px; height:74px; object-fit:cover; display:block; }

//     .title { text-align:center; color:#fff; line-height:1; max-width:820px; padding:0 40px; }
//     .title h1 { font-size:34px; font-weight:900; margin:2px 0 2px; line-height:1.02; letter-spacing:0.6px; }
//     .title h2 { font-size:18px; font-weight:700; margin:2px 0 4px; }
//     .title p { font-size:13px; margin:6px 0 0; color:#fff; font-weight:700; }

//     .body {
//       padding: 18px 24px 32px;
//       position: relative;
//       z-index: 2;
//     }

//     .info-box { border:1px solid rgba(0,0,0,0.18); border-radius:6px; padding:12px 16px; margin-top:8px; display:flex; gap:18px; background:#fff; justify-content:space-between; align-items:flex-start; }
//     .info-left { font-size:13.5px; line-height:1.7; flex:1 1 60%; }
//     .info-right { display:grid; gap:6px 12px; font-size:13.5px; line-height:1.7; width:220px; text-align:right; }

//     .table-wrapper { position:relative; width:100%; display:inline-block; margin-top:14px; }

//     /* Single centered watermark inside the table wrapper */
//     .table-watermark--table {
//       position: absolute;
//       top: 50%;
//       left: 50%;
//       transform: translate(-50%, -50%);
//       opacity: 0.12;
//       z-index: 0;               /* behind the table */
//       pointer-events: none;
//       filter: blur(1.2px);
//       width: 360px;             /* control watermark size */
//       max-width: 60%;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//     .table-watermark--table img {
//       width: 100%;
//       height: auto;
//       display:block;
//     }

//     table.items { width:100%; border-collapse:collapse; margin-top:6px; font-size:13.5px; border:1px solid rgba(0,0,0,0.25); position:relative; z-index:1; }
//     table.items th, table.items td { padding:8px 8px; border:1px solid rgba(0,0,0,0.12); background:transparent; }
//     table.items thead th { background:#f9f9f9; font-weight:700; font-size:13px; }
//     .col-center { text-align:center; }
//     .col-right { text-align:right; }

//     .sub-box { margin-top:16px; display:flex; justify-content:flex-end; }
//     .sub-table { width:340px; border-collapse:collapse; font-size:13.5px; }
//     .sub-table td { padding:8px 6px; border-top:1px solid rgba(0,0,0,0.08); }
//     .sub-table .label { text-align:left; color:#222; }
//     .sub-table .val { text-align:right; font-weight:700; }

//     .totals-line { margin-top:18px; font-size:15px; font-weight:700; display:flex; justify-content:space-between; }

//     .footer-note { margin-top: 12px; font-size:13px; color: #111; }

//     .bottom-bar {
//       background: #d81b2e;
//       color: #fff;
//       padding: 10px 8px;
//       text-align: center;
//       font-weight: 800;
//       font-size: 14px;
//       position: absolute;
//       bottom: 0;
//       left: 0;
//       right: 0;
//       width: 100%;
//       line-height: 1.4;
//     }

//     @media print {
//       html, body { background: #fff; margin: 0; padding: 0; }
//       .page { width: auto; margin: 0; box-shadow: none; min-height: auto; padding-bottom: 70px; }
//       @page { size: A4; margin: 6mm; }
//       .bottom-bar { position: fixed; bottom: 0; left: 0; right: 0; }
//       .header { padding: 22px 12px 18px; }
//       .logo { left: 10px; top: 10px; }
//     }
//   </style>
// </head>
// <body>
//   ${allPagesHtml}
// </body>
// </html>`;
// }

// export function BillPrintPreview({ bill }) {
//   const html = renderBillToHtml(bill);
//   return <div dangerouslySetInnerHTML={{ __html: html }} />;
// }

// export default BillPrintPreview;

import React from "react";

export function renderBillToHtml(bill = {}) {
  // Prefer ISO timestamp (has exact time). If not present, fall back to bill.date or now.
  const createdDateObj = bill.timestamp
    ? new Date(bill.timestamp)
    : bill.date
    ? new Date(bill.date)
    : new Date();

  const formattedDate = createdDateObj.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const formattedTime = createdDateObj.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // Use 12-hour format
    timeZone: "Asia/Kolkata",
  });

  const items = Array.isArray(bill.items) ? bill.items : [];
  const total = Number(
    bill.total ??
      items.reduce(
        (s, it) => s + Number(it.price || 0) * Number(it.quantity || 0),
        0
      )
  );
  const paid = Number(bill.paid || 0);
  const balance = Number(bill.balance ?? Math.max(0, total - paid));

  const totalFmt = total.toFixed(2);
  const paidFmt = paid.toFixed(2);
  const balanceFmt = balance.toFixed(2);

  const chunkSize = 12;
  let pages = [];
  if (items.length === 0) pages = [[]];
  else {
    for (let i = 0; i < items.length; i += chunkSize) {
      pages.push(items.slice(i, i + chunkSize));
    }
  }

  const generatePage = (pageItems, pageIndex) => {
    const isLastPage = pageIndex === pages.length - 1;
    const startIndex = pageIndex * chunkSize;

    const rowsHtml = pageItems
      .map((item, idx) => {
        const price = Number(item.price || 0);
        const qty = Number(item.quantity || 0);
        const amt = (price * qty).toFixed(2);
        const name = item.product || item.name || "-";
        return `
          <tr>
            <td class="col-center">${startIndex + idx + 1}</td>
            <td>${name}</td>
            <td class="col-right">₹${price.toFixed(2)}</td>
            <td class="col-center">${qty}</td>
            <td class="col-right">₹${amt}</td>
          </tr>`;
      })
      .join("");

    const emptyRowsCount = Math.max(0, chunkSize - pageItems.length);
    const emptyRows = Array.from({ length: emptyRowsCount })
      .map(
        () => `
        <tr>
          <td class="col-center">&nbsp;</td>
          <td></td>
          <td class="col-right"></td>
          <td class="col-center"></td>
          <td class="col-right"></td>
        </tr>`
      )
      .join("");

    return `
      <div class="page">

        <div class="header">
          <div class="header-top">${bill.headerTopText || ""}</div>

          <div class="logo" style="width: 120px; height: 120px;">
            <div class="logo-circle">
              <img src="${bill.logoPath || "/logo.png"}" alt="logo" />
            </div>
          </div>

        <<div class="title" style="margin-left: 60px;">
  <p style="font-size:13px; margin:0 0 6px; font-weight:700;">${
    bill.subtitleTop || "உ"
  }</p>
  <p style="font-size:13px; margin:0 0 6px; font-weight:700;">${
    bill.subtitleSub || "ஸ்ரீ பெரியாண்டவர் துணை"
  }</p>
  <h1>${bill.titleLine1 || "ஸ்ரீ முருகன் ஆயுர்வேத"}</h1>
  <h2>${bill.titleLine2 || "ஆலோசனை மையம்"}</h2>
  <p style="font-size:13px; margin:8px 0 0; font-weight:600;">${
    bill.addressLine ||
    "142-A, அந்தியூர் மேயின் ரோடு, லட்சுமி மருத்துவமனை அருகில், பவானி - 638 301"
  }</p>
</div>


        </div>

        <div class="body">
          <div class="info-box">
            <div class="info-left">
              <div><strong>To:</strong> ${
                bill.workerName || bill.customerName || "—"
              }</div>
              <div><strong>Address:</strong> ${bill.address || "—"}</div>
              <div><strong>Mobile:</strong> ${bill.mobile || "—"}</div>
              ${
                bill.gst ? `<div><strong>GSTIN:</strong> ${bill.gst}</div>` : ""
              }
            </div>
            <div class="info-right">
              <div><strong>Invoice No :</strong> ${bill.invoiceNo || "—"}</div>
              <div><strong>Date :</strong> ${formattedDate}</div>
              <div><strong>Time :</strong> ${formattedTime}</div>
            </div>
          </div>

          <div class="table-wrapper">
            <div class="table-watermark--table" aria-hidden="true">
              <img src="${
                bill.logoPath1 || "/logo1.png"
              }" alt="table-watermark" />
            </div>

            <table class="items" style="position:relative; z-index:1;">
              <thead>
                <tr>
                  <th style="width:6%;">S.No</th>
                  <th style="width:54%;">Particulars</th>
                  <th style="width:14%; text-align:right;">Rate</th>
                  <th style="width:8%; text-align:center;">Qty</th>
                  <th style="width:18%; text-align:right;">Amount</th>
                </tr>
              </thead>
              <tbody>
                ${rowsHtml}
                ${emptyRows}
              </tbody>
            </table>
          </div>

          ${
            isLastPage
              ? `
          <div class="sub-box">
            <table class="sub-table">
              <tr><td class="label">Sub Total</td><td class="val">₹${totalFmt}</td></tr>
              ${
                bill.discount
                  ? `<tr><td class="label">Discount</td><td class="val">₹${Number(
                      bill.discount
                    ).toFixed(2)}</td></tr>`
                  : ""
              }
              <tr><td class="label">Net Amount</td><td class="val">₹${totalFmt}</td></tr>
              ${
                bill.payment_type === "Credit"
                  ? `<tr><td class="label">Paid</td><td class="val">₹${paidFmt}</td></tr>
                     <tr><td class="label">Balance Due</td><td class="val">₹${balanceFmt}</td></tr>`
                  : `<tr><td class="label">Payment Type</td><td class="val">${
                      bill.payment_type || "Cash"
                    }</td></tr>`
              }
            </table>
          </div>

          <div class="totals-line">
            <div>Total Items: ${items.reduce(
              (s, it) => s + Number(it.quantity || 0),
              0
            )}</div>
            <div>Total Amount: ₹${totalFmt}</div>
          </div>

          <div class="footer-note">குறிப்பு : ஒருமுறை விற்ற பொருள் திரும்ப பெறப்படமாட்டாது</div>
          `
              : `<div class="footer-note" style="margin-top:40px; text-align:center;">Page ${
                  pageIndex + 1
                } of ${pages.length}</div>`
          }

        </div>

         <div class="bottom-bar">
           <div class="contact-left">📞 99408 32688 , 90801 99109</div>
           <div class="contact-right">✉️ srimuruganayurveda@gmail.com</div>
         </div>
      </div>
      ${
        pageIndex < pages.length - 1
          ? `<div style="page-break-after: always;"></div>`
          : ""
      }
    `;
  };

  const allPagesHtml = pages.map((p, idx) => generatePage(p, idx)).join("");

  return `<!doctype html>
<html lang="ta">
<head>
  <meta charset="utf-8" />
  <title>Invoice ${bill.invoiceNo || ""}</title>
  <meta name="viewport" content="width=device-width,initial-scale=1" />
  <style>
    * { box-sizing: border-box; }
    html,body { margin:0; padding:0; -webkit-print-color-adjust: exact; print-color-adjust: exact; font-family:"Helvetica Neue", Arial, sans-serif; background:#f4f4f4; }
    .page {
      width: 210mm;
      min-height: 287mm;
      background: #fff;
      box-shadow: 0 2px 8px rgba(0,0,0,0.06);
      margin: 12mm auto;
      position: relative;
      padding-bottom: 70px;
      overflow: hidden;
    }

    .header {
      width:100%;
      background:#d81b2e;
      display:flex;
      align-items:center;
      justify-content:center;
      padding:28px 20px 22px;
      position:relative;
    }

    .header-top {
      position: absolute;
      top: 6px;
      left: 0;
      right: 0;
      text-align: center;
      font-size: 12px;
      color: #fff;
      font-weight: 800;
      letter-spacing: 0.4px;
    }

    .logo {
      position: absolute;
      left: 18px;
      top: 35px;
      width: 120px;
      height: 120px;
      display:flex;
      margin-top:20px;
      align-items:center;
      justify-content:center;
    }
    .logo-circle {
      width:108px;
      height:108px;
      border-radius:50%;
      background:#fff;
      display:flex;
      align-items:center;
      justify-content:center;
      box-shadow: 0 2px 6px rgba(0,0,0,0.12);
      padding:6px;
      overflow:hidden;
    }
    .logo-circle img {
      width:96px;
      height:96px;
      object-fit:cover;
      display:block;
    }

    .title { text-align:center; color:#fff; line-height:1; max-width:820px; padding:0 40px; }
    .title h1 { font-size:42px; font-weight:900; margin:2px 0 2px; line-height:1.1; letter-spacing:0.8px; }
    .title h2 { font-size:26px; font-weight:800; margin:2px 0 4px; }
    .title p { font-size:13px; margin:6px 0 0; color:#fff; font-weight:700; }

    .body { padding: 18px 24px 32px; position: relative; z-index: 2; }
    .info-box { border:1px solid rgba(0,0,0,0.18); border-radius:6px; padding:12px 16px; margin-top:8px; display:flex; gap:18px; background:#fff; justify-content:space-between; align-items:flex-start; }
    .info-left { font-size:13.5px; line-height:1.7; flex:1 1 60%; }
    .info-right { display:grid; gap:6px 12px; font-size:13.5px; line-height:1.7; width:220px; text-align:right; }

    .table-wrapper { position:relative; width:100%; display:inline-block; margin-top:14px; }

    .table-watermark--table {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0.12;
      z-index: 0;
      pointer-events: none;
      filter: blur(1.2px);
      width: 360px;
      max-width: 60%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .table-watermark--table img { width: 100%; height: auto; display:block; }

    table.items { width:100%; border-collapse:collapse; margin-top:6px; font-size:13.5px; border:1px solid rgba(0,0,0,0.25); position:relative; z-index:1; }
    table.items th, table.items td { padding:8px 8px; border:1px solid rgba(0,0,0,0.12); }
    table.items thead th {  font-weight:700; font-size:13px; }

    .col-center { text-align:center; }
    .col-right { text-align:right; }

    .sub-box { margin-top:16px; display:flex; justify-content:flex-end; }
    .sub-table { width:340px; border-collapse:collapse; font-size:13.5px; }
    .sub-table td { padding:8px 6px; border-top:1px solid rgba(0,0,0,0.08); }
    .sub-table .label { text-align:left; color:#222; }
    .sub-table .val { text-align:right; font-weight:700; }

    .totals-line { margin-top:18px; font-size:15px; font-weight:700; display:flex; justify-content:space-between; }

    .footer-note { margin-top: 12px; font-size:13px; color: #111; }

.bottom-bar {
  background: #d81b2e;
  color: #fff;
  padding: 10px 20px;
  text-align: center;
  font-weight: 800;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  margin: 0;
  line-height: 1.4;
  display: flex;
  justify-content: space-between;
  align-items: center;
}



.bottom-bar .contact-left { text-align: left; }
.bottom-bar .contact-right { text-align: right; }



    @media print {
      html, body { background: #fff; margin: 0; padding: 0; }
      .page { width: auto; margin: 0; box-shadow: none; min-height: auto; padding-bottom: 70px; }
      @page { size: A4; margin: 6mm; }
      .bottom-bar { position: fixed; bottom: 0; left: 0; right: 0; }
      .header { padding: 22px 12px 18px; }
      .logo { left: 10px; top: 10px; }
    }
  </style>
</head>
<body>
  ${allPagesHtml}
</body>
</html>`;
}

export function BillPrintPreview({ bill }) {
  const html = renderBillToHtml(bill);
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}

export default BillPrintPreview;
